import React from "react";
import { motion, MotionConfig } from "framer-motion";
import { AlertTriangle, Clock, Mail, ArrowLeftRight } from "lucide-react";
import { Link } from "react-router-dom";
/**
 * PageUnderReview (Bootstrap version)
 * A reusable React component styled using Bootstrap 5 classes.
 *
 * Props:
 *  - title: string (optional)
 *  - message: string (optional)
 *  - estimatedDays: number (optional)
 *  - onBack: function (optional)
 *  - contactEmail: string (optional)
 */

export default function PageUnderReview({
    title = "Page Under Review",
    message = "We appreciate your decision to join the Neoo Search business directory. Your company page is being evaluated; expect it to live within 1-3 days.",
    estimatedDays = null,
    onBack = null,
    contactRoute = null,
    contactEmail = null,
    contactPhone = null
}) {
    return (
        <MotionConfig transition={{ duration: 0.4 }}>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="d-flex justify-content-center align-items-center min-vh-100 bg-light p-3"
            >
                <div className="card shadow-lg w-100" style={{ maxWidth: "600px" }}>
                    <div className="card-body p-4 p-md-5">
                        <div className="d-flex align-items-start mb-3">
                            {/* <div className="bg-warning bg-opacity-10 rounded d-flex align-items-center justify-content-center me-3" style={{ width: "60px", height: "60px" }}>
                <AlertTriangle size={28} className="text-warning" />
              </div> */}
                            <div>
                                <h4 className="card-title mb-2 text-dark fw-semibold p-2">{title}</h4>
                                <p className="text-muted mb-0">Dear esteemed client,</p>
                                <p className="text-muted mb-0">{message}</p>
                            </div>
                        </div>

                        {estimatedDays !== null && (
                            <div className="d-flex align-items-center mt-3 text-secondary small">
                                <Clock size={16} className="me-2" />
                                Typical review time: <strong className="ms-1">{estimatedDays} day{estimatedDays > 1 ? "s" : ""}</strong>
                            </div>
                        )}

                        <div className="mt-4 d-flex flex-wrap align-items-center gap-2">

                            {contactRoute && (
                                <Link className="btn btn-outline-secondary d-flex align-items-center gap-2"
                                    to={`/${contactRoute}`}
                                >
                                    <Mail size={16} /> &nbsp;{contactRoute ? "Contact Support" : "Need Help?"}
                                </Link>
                            )}

                            <div className="ms-auto text-muted small p-2">Status: <span className="fw-semibold text-dark">Under Review</span></div>

                        </div>

                        <div className="mt-4 small text-muted border-top pt-3">
                            <strong className="text-dark">Note:</strong> While the review is in progress, some features of your page may be restricted.
                        </div>

                        <div className="mt-3 border-top pt-3">
                            <p className="small text-secondary mb-1">
                                If you think this is a mistake, reach out to our support team and include your page name and submission ID for faster resolution.
                            </p>
                            {contactPhone && (
                            <p className="small text-secondary mb-1">Call/whatsapp : {contactPhone}</p>
                            )}
                            {contactEmail && (
                            <p className="small text-secondary mb-0">Email : {contactEmail}</p>
                            )}
                        </div>
                    </div>
                </div>
            </motion.div>
        </MotionConfig>
    );
}